import React from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { Spacer } from "../atoms/Atoms"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"
import L10n from "../../../lib/carrot-l10n"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../atoms/Bodies"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HelpFindingProviderModule = () => (
  <RoundedRectangle backgroundColor="mint-alternate">
    <RRIconBar iconName="icn-find" iconBackgroundColor="white-60" />
    <H3 variant="primary" stack="tiny">{l`needHelp`}</H3>
    <BodySmall>{l`contactCareNav`}</BodySmall>
    <RRButtonFooter outline to="/talk-to-carrot/sendmessage/helpfindingprovider">
      {l`contactUs`}
    </RRButtonFooter>
  </RoundedRectangle>
)

export { HelpFindingProviderModule }
